import script from "./VInputDatepickerNext.vue?vue&type=script&setup=true&lang=ts"
export * from "./VInputDatepickerNext.vue?vue&type=script&setup=true&lang=ts"

import "./VInputDatepickerNext.vue?vue&type=style&index=0&id=179a36de&scoped=true&lang=postcss"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-179a36de"]])

export default __exports__